export default __webpack_public_path__ + "static/media/sun-arrow-up.6697a303.svg";